import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { GameStateType } from "types/game";

import { extraReducers } from "./game.extraReducers";
import { reducers } from "./game.reducers";

export const initialState: GameStateType = {
  isLoading: false,
  categoryGameList: [],
  // categoryGameSlots: [],
  // categoryGameLiveCasino: [],
  // categoryGameESport: [],
  // categoryGameSport: [],
  dataSubGame: {
    data: [],
    currentPage: 1,
    game_type: "",
    msg: "",
    pageSize: 100,
    status: 0,
    totalCount: 0,
    totalPages: 0,
  },
  dataSubGameFeatured: [],
  prevProvider: "",
  categoryGame: {
    id: "",
    path: "",
    name: "",
  },
  msgError: "",
};

const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: reducers,
  extraReducers,
});

export const selectSubGameList = (state: ApplicationRootState) =>
  state.game.dataSubGame;

export const selectSubGameFeatured = (state: ApplicationRootState) =>
  state.game.dataSubGameFeatured;

export const selectCategoryGameList = (state: ApplicationRootState) =>
  state.game.categoryGameList;

// export const selectCategoryGameSlots = (state: ApplicationRootState) =>
//   state.game.categoryGameSlots;

// export const selectCategoryGameLiveCasino = (state: ApplicationRootState) =>
//   state.game.categoryGameLiveCasino;

// export const selectCategoryGameESport = (state: ApplicationRootState) =>
//   state.game.categoryGameESport;

// export const selectCategoryGameSport = (state: ApplicationRootState) =>
//   state.game.categoryGameSport;

export const selectIsLoading = (state: ApplicationRootState) =>
  state.game.isLoading;

export const selectCategoryGame = (state: ApplicationRootState) =>
  state.game.categoryGame;

export const selectMsgError = (state: ApplicationRootState) =>
  state.game.msgError;

export const selectPrevProvider = (state: ApplicationRootState) =>
  state.game.prevProvider;

export const { resetGame, setPrevProvider, setCategoryGame, resetDataSubGame } =
  gameSlice.actions;

export default gameSlice.reducer;
